module.exports = __webpack_public_path__ + "a75548ccb80e85ed20690d8a90918a7a.png";